import { render, staticRenderFns } from "./recipients.vue?vue&type=template&id=59704105&"
import script from "./recipients.vue?vue&type=script&lang=ts&"
export * from "./recipients.vue?vue&type=script&lang=ts&"
import style0 from "./recipients.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports